import React, { useState, useCallback, useEffect } from "react";

import { useNavigate, useRouteLoaderData, Link } from "react-router-dom";
import Box from "@mui/material/Box";
import { Tab, Tabs } from "@mui/material";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import ClientPaymentForm from "Components/ClientPayment/ClientBankFileForm";
import Paper from "Components/UI/Paper";
import { deleteClientPayment, getClients, getFiles } from "API/swesum";
import { useClientPayment } from "Context/ClientPayment";
import { useClients } from "Context/Clients";
import { usePopupNotificationContext } from "Context/NotificationPopup";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "400px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}

export function ClientPaymentCard() {
  const { clientPayment, updateClientPayment } = useClientPayment();
  const [files, setFiles] = useState([]);
  const [tabIndex, setTabindex] = useState(0);
  const [loading, setLoading] = useState(false);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };
  const { clients, fetchClients, hasFetchedAll } = useClients();
  const [dialogOpen, setDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { openSuccess, openError } = usePopupNotificationContext();

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (clientPayment) {
      setFormData({
        Id: clientPayment.Id,
        Amount: clientPayment.Amount,
        Status: clientPayment.Status,
        ClientId: clientPayment.ClientId,
        CreateTime: clientPayment.CreateTime,
        FileId: clientPayment.FileId,
        SystemStatus: clientPayment.SystemStatus,
        ParseStatus: clientPayment.ParseStatus,
        ParseMessage: clientPayment.ParseMessage,
      });
    }
  }, [clientPayment]);

  const fetchFilesNClients = async () => {
    setLoading(true);
    if (!hasFetchedAll) {
      fetchClients();
    }
    const files = await getFiles();
    setFiles(files);
    setLoading(false);
  };

  useEffect(() => {
    fetchFilesNClients();
  }, []);

  const handleInputChange = useCallback(
    (field, newVal) => {
      setFormData({ ...formData, [field]: newVal });
    },
    [formData]
  );

  const updateInvoicee = async () => {
    const res = await updateClientPayment(formData);
    if (res.status === 201) {
      openSuccess("Sparat", 3000);
    } else {
      openError("Ett fel har uppstått vid uppdatering av fakturan", 2000);
    }
  };

  const deleteInvoice = async () => {
    const res = await deleteClientPayment(clientPayment.Id);
    if (res.status === 201) {
      closeDialog();
      navigate("/clientpayments");
    } else {
      closeDialog();
      openError("Ett fel uppstod när fakturan sparades");
    }
  };

  const closeDialog = () => {
    setDialogOpen(false);
  };

  if (!formData || loading) {
    return null;
  }

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} md={12}>
          <Paper>
            <Typography
              sx={{ marginBottom: "1.0rem" }}
              variant="h5"
              align="left"
            >
              Klientutbetalningskort
            </Typography>
            {formData && (
              <ClientPaymentForm
                formData={formData}
                clients={clients}
                files={files}
                handleInputChange={handleInputChange}
              />
            )}
            <Grid
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Button onClick={() => navigate(-1)} sx={{ ml: 1 }}>
                Stäng
              </Button>

              <Button
                onClick={updateInvoicee}
                sx={{ ml: 3 }}
                variant="contained"
              >
                Spara
              </Button>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} md={12}>
          <Paper>
            <Tabs
              value={tabIndex}
              onChange={handleTabSwitch}
              sx={{ marginBottom: "2rem" }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab label="Workflow1" />
            </Tabs>
            <TabPanel value={tabIndex} index={0} id="tabPanel0">
              <h1>Workflow1</h1>
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>{"Ta bort faktura"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {
              "Fakturan kommer att tas bort från systemet. Åtgärden går inte att ångra."
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Stäng</Button>
          <Button color="error" onClick={() => deleteInvoice()} autoFocus>
            Ta bort
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
